import { render, staticRenderFns } from "./OperationsByProduct.vue?vue&type=template&id=35358fc6"
import script from "./OperationsByProduct.vue?vue&type=script&lang=js"
export * from "./OperationsByProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports